module.exports = __webpack_public_path__ + "static/img/ady1.29f1216.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ady1.png
// module id = iW/g
// module chunks = 1